import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const truncateWords = (text, limit = 20) => {
  if (!text) return "";
  const words = text.trim().split(/\s+/);
  if (words.length <= limit) return text;
  return words.slice(0, limit).join(" ") + "...";
};

export function OurCourseCard({activState,...props}) {
  const truncatedPara = truncateWords(props?.item?.para || "", 20);

  return (
    <div
      className={`flex flex-col h-full w-[300px] mx-auto ${
        props?.indxz === activState
          ? `mt-20 scale-125 transition ease-in-out duration-400 `
          : ` mt-20 ease-in-out scale-100`
      }  `}
    >
      <div
        className={` relative flex rounded-[20px] object-cover overflow-hidden mx-auto ${
          props?.indxz === activState ? `h-[200px] w-[200px] xs:h-[260px] xs:w-[260px]  ` : `h-[240px] w-[240px]`
        }`}
      >
        <img src={props?.item?.image} alt="" className="w-full imgGradent " />
        <div
          className="w-full h-full absolute opacity-50"
          style={{
            backgroundImage:
              "radial-gradient(circle farthest-corner at 100% 0%, rgba(8, 28, 58, 0.8) 31%, rgba(50, 114, 122, 0.8))",
          }}
        />
      </div>
      {props?.indxz === activState && (
        <div className="max-w-[500px] pt-[15px]">
          <div className="flex flex-col min-h-[160px] justify-between">
            <motion.div
              initial={{ opacity: 0, rotate: 5 }}
              whileInView={{ opacity: 1, rotate: 0 }}
              transition={{ duration: 0.5 }}
              key="1"
            >
              <div className={`${props?.item?.style || 'text-[20px]'} text-center px-6 items-center my-[10px] text-[#333] font-bold leading-snug`}>
                {props?.item?.heading}
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, rotate: 5 }}
              whileInView={{ opacity: 1, rotate: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.2 }}
              key="2"
            >
              <div className="text-[12px] mb-[15px] flex justify-center items-center px-6 text-center text-[grey] font-semibold leading-relaxed">
                {truncatedPara}
              </div>
            </motion.div>
          </div>
          <div className="flex px-6 flex-row justify-between items-center mt-4">
            <Link
              to={props?.item?.moreDetails || '#'}
              onClick={() => {
                window.scroll(0, 0);
              }}
              className="flex-1 mr-4"
            >
              <div
                className="w-full h-[40px] flex justify-center items-center rounded-full text-white font-bold text-xs"
                style={{
                  backgroundImage:
                    "linear-gradient(135deg, #081c3a 40%, #32727a)",
                }}
              >
                More details
              </div>
            </Link>
            <motion.div
              initial={{ opacity: 0, rotate: 5, scale: 0.6 }}
              whileInView={{ opacity: 1, rotate: 0, scale: 1 }}
              transition={{ duration: 0.9, delay: 0.2 }}
              key="3"
              className="flex-shrink-0"
            >
              <Link
                to={props?.item?.viewAll || '#'}
                onClick={() => {
                  window.scroll(0, 0);
                }}
              >
                <div className="h-[40px] px-2 flex justify-center items-center text-xs font-bold text-[#32727a] hover:underline">
                  View All
                </div>
              </Link>
            </motion.div>
          </div>
        </div>
      )}
    </div>
  );
}
